import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Panel } from './atoms/Panel';
import { BackButton } from './atoms/BackButton';
import { ConfigurationType } from '../types';
import { useDependencies } from '../hooks/useDependencies';
import { ActionOption, ButtonWithActionMenu } from './atoms/ButtonWithActionMenu';
import { TitleWithSubtitle } from './atoms/TitleWithSubtitle';
import { selectDependenciesHistoryLength } from '../../../../reducers/documentation/documentationReducer';
import { useSelector } from 'react-redux';
import { MiddlePanel } from './atoms/MiddlePanel';
import { ConfigurationItem } from '../../../parser/ParserTypes';
import { useFeatureToggle } from '../../../../feature-flags/useFeatureToggle';
import { DependenciesSearchInput } from '../search/DependenciesSearchInput';
import { DependenciesSearchEntryIcon } from '../search/DependenciesSearchEntryIcon';

interface SourceCodeHeaderProps {
  configurationItem: ConfigurationItem;
  type: ConfigurationType;
  crmOrgId: string;
  readOnly?: boolean;
}

export const SourceCodeHeader = ({ configurationItem, type, crmOrgId }: SourceCodeHeaderProps) => {
  const { searchInDocumentationCard } = useFeatureToggle();
  const { onGoToDependenciesMainView, onGoBackInHistory } = useDependencies(crmOrgId);
  const historyLength = useSelector(selectDependenciesHistoryLength);
  const onGoBackFunc = historyLength > 1 ? onGoBackInHistory : onGoToDependenciesMainView;

  const { updatedBy, updatedAt } = configurationItem ?? {};

  return (
    <Panel sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 0 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        gap={1}
        alignItems="center"
        width="100%"
      >
        <BackButton onClick={onGoBackFunc} />
        <Box flex={1} display="flex" justifyContent="space-between" alignItems="flex-start">
          <TitleWithSubtitle
            parentType={type}
            configurationItem={configurationItem}
            crmOrgId={crmOrgId}
          />

          <MiddlePanel>
            {searchInDocumentationCard && <DependenciesSearchEntryIcon />}
            <ButtonWithActionMenu
              options={[ActionOption.openInSalesforce, ActionOption.comments]}
              configurationItem={configurationItem}
              crmOrgId={crmOrgId}
              lastUpdatedInfo={updatedBy && updatedAt ? { updatedBy, updatedAt } : undefined}
            />
          </MiddlePanel>
        </Box>
      </Stack>
      {searchInDocumentationCard && <DependenciesSearchInput />}
    </Panel>
  );
};
